import React from 'react';
import ReactPlaceholder from 'react-placeholder';
import styles from 'react-placeholder/lib/reactPlaceholder.css';
import { LazyStylesComponent } from '../../../common/components/LazyStylesComponent';
import { CustomPlaceholder } from './CustomPlaceholder';
export var CommonVisualNavigationPlaceholder = function (_a) {
    var showTitle = _a.showTitle, children = _a.children, ready = _a.ready;
    return (React.createElement(LazyStylesComponent, { styles: styles, identifier: "skeleton" },
        React.createElement(ReactPlaceholder, { ready: ready, customPlaceholder: React.createElement(CustomPlaceholder, { showLoadingAnimation: true, showTitle: showTitle }) }, children)));
};
